import React from 'react';

export const ArrowRight = ({ className }) => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" className={className}>
    <path d="M0.5 7.5H15.5M15.5 7.5L11.1452 3M15.5 7.5L11.1452 12" stroke="currentColor" />
  </svg>
);
